module.exports = __webpack_public_path__ + "img/3b044.0096aa55.svg";